import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box'

export default function LoadingComponent({ size, sxClasses }) {
  return <Box sx={{ display: 'flex', justifyContent: 'center', py: 2, ...sxClasses }} >
    <CircularProgress size={size ? size : '1.5rem'} />
  </Box>
};
